import React, {useEffect, useState, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {rxrPrimaryColor, rxrSecondaryPrimaryGrayColor} from '../../assets/styles/color'
import moment from 'moment'
import {capitalizeFirstLetter} from '../../Utils/StringFormatter'
import {getAmenityReservationDetails} from '../../lib/queries'
import Loader from '../Loader'
import TimelineEvent from './TimelineEvent'
import {useSelector, useDispatch} from 'react-redux'
import {loadAmenitiesForBuilding} from '../../actions/amenitiesActions'
import {selectActiveBuildingAndSisterBuildingIds} from '../../reducers/selectors'

const useStyles = makeStyles(theme => ({
  infoTitle: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: '400',
    fontStyle: 'normal',
    color: rxrSecondaryPrimaryGrayColor,
  },
  infoData: {
    fontSize: 16,
    lineHeight: '16px',
    fontWeight: '400',
    fontStyle: 'normal',
    color: rxrPrimaryColor,
    paddingTop: '4px',
  },
  loader: {
    paddingTop: '120px',
    backgroundColor: 'transparent ',
    opacity: 1,
  },
}))

function AmenityReservation(props) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const amenitiesLookup = useSelector(state => state.Amenities.amenitiesLookup)
  const buildingIds = useSelector(selectActiveBuildingAndSisterBuildingIds)
  const [amenityReservationInfo, setAmenityReservationInfo] = useState({})
  const [isAmenityReservationInfoLoading, setAmenityReservationInfoLoading] = useState(true)
  const [isLoadingAmenities, setIsLoadingAmenities] = useState(false)

  /**
   * Common function for rendeing data point.
   * @param {*} title
   * @param {*} data
   * @returns {string}
   */
  const renderInfo = (title, data) => (
    <Grid container direction="column" style={{paddingBottom: '24px'}}>
      <Grid item>
        <div className={classes.infoTitle}>{title}</div>
      </Grid>
      <Grid item>
        <div className={classes.infoData}>{data ? data : '--'}</div>
      </Grid>
    </Grid>
  )

  useEffect(() => {
    getAmenityReservationDetails(props.amenityReservationId)
      .then(res => {
        setAmenityReservationInfo(res)
        setAmenityReservationInfoLoading(false)
      })
      .catch(err => console.error(err))
  }, [props.amenityReservationId])

  // Load amenities if they're not already loaded
  useEffect(() => {
    if (buildingIds.length > 0 && Object.keys(amenitiesLookup).length === 0 && !isLoadingAmenities) {
      setIsLoadingAmenities(true)
      loadAmenitiesForBuilding(dispatch, buildingIds).finally(() => setIsLoadingAmenities(false))
    }
  }, [buildingIds, amenitiesLookup, isLoadingAmenities, dispatch])

  const startAt = amenityReservationInfo.startAt ? `${moment(amenityReservationInfo.startAt).format('LT')}` : ''
  const endAt = amenityReservationInfo.endAt ? `${moment(amenityReservationInfo.endAt).format('LT')}` : ''
  const date = amenityReservationInfo.startAt ? `${moment(amenityReservationInfo.startAt).format('ll')}` : ''

  return (
    <Fragment>
      {isAmenityReservationInfoLoading || isLoadingAmenities ? (
        <Loader className={classes.loader} />
      ) : (
        <div>
          {renderInfo('Amenity', amenitiesLookup[amenityReservationInfo.amenityId]?.label || 'Loading...')}
          {renderInfo('Status', amenityReservationInfo.reservationState && capitalizeFirstLetter(amenityReservationInfo.reservationState))}
          {renderInfo('Start time', startAt)}
          {renderInfo('End time', endAt)}
          {renderInfo('Date', date)}
          <TimelineEvent primaryRecordId={props.amenityReservationId} />
        </div>
      )}
    </Fragment>
  )
}

AmenityReservation.propTypes = {
  amenityReservationId: PropTypes.string.isRequired,
}

export default AmenityReservation
